import classNames from 'classnames';
import styles from './ProfileImage.module.css';
import React, { CSSProperties } from 'react';
import { QuirkImage } from './QuirkImage';

const PROFILE_IMAGE_SIZES = ['small', 'xsmall', 'xxsmall', 'tiny', 'medium', 'large', 'avatar'] as const;

export type ProfileImageSize = (typeof PROFILE_IMAGE_SIZES)[number];
export interface ProfileImageProps {
	size: ProfileImageSize;
	background?: string;
	url?: string;
	text?: string | null;
	contain?: boolean;
	border?: boolean;
	shape?: 'square' | 'circle';
	alt?: string;
	fallback?: string | JSX.Element;
	statusIcon?: React.ReactNode;
	testId?: string;
}

function isCustomSize(size: string): boolean {
	return !PROFILE_IMAGE_SIZES.includes(size as ProfileImageSize);
}

export const ProfileImage: React.FC<ProfileImageProps> = ({
	size,
	background = 'inherit',
	url,
	text = '',
	contain,
	border,
	shape = 'circle',
	alt = '',
	fallback,
	statusIcon,
	testId
}: ProfileImageProps) => {
	const style: CSSProperties = { background };
	if (isCustomSize(size)) {
		style.width = size;
		style.height = size;
	}
	return (
		<div
			data-testid={testId}
			className={classNames(styles.profilePic, {
				[styles.profilePicSmall]: size === 'small',
				[styles.profilePicXSmall]: size === 'xsmall',
				[styles.profilePicXXSmall]: size === 'xxsmall',
				[styles.profilePicTiny]: size === 'tiny',
				[styles.profilePicLarge]: size === 'large',
				[styles.profilePicMedium]: size === 'medium',
				[styles.profilePicAvatar]: size === 'avatar',
				[styles.contain]: contain === true,
				[styles.border]: border === true,
				[styles.square]: shape === 'square',
				[styles.circle]: shape === 'circle',
				[styles.hasIcon]: statusIcon !== undefined
			})}
			style={style}
		>
			{url !== undefined && url !== '' && (
				<div className={styles.IonImg}>
					<QuirkImage src={url} alt={alt} fallback={fallback} contain={contain} />
				</div>
			)}
			{!url && text}
			{statusIcon && <span className={styles.statusIcon}>{statusIcon}</span>}
		</div>
	);
};
